import { useMutation } from '@tanstack/react-query';
import { UserWalletCompanyInfoService } from 'services/openapi';

type UpdateCompMutationVariables = {
  compId: string;
  compName: string;
  compInfo: string;
};

export const useUpdateCompMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<any, Error, UpdateCompMutationVariables>({
      mutationFn: (variables: UpdateCompMutationVariables) => {
        return UserWalletCompanyInfoService.companyControllerUpdateComp(
          variables.compId,
          { ...variables },
        );
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
